import { render } from "./UserManagementDataTable.vue?vue&type=template&id=dd7144ce&scoped=true"
import script from "./UserManagementDataTable.vue?vue&type=script&lang=js"
export * from "./UserManagementDataTable.vue?vue&type=script&lang=js"

import "./UserManagementDataTable.vue?vue&type=style&index=0&id=dd7144ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd7144ce"]])

export default __exports__